import Vue from "vue";
import Router from "vue-router";
import Chapter from "./views/Chapter.vue";
import Screen from "./views/Screen.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/home",
      //redirect: "/home",
      name: "Home",
      props: true,
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Home.vue")
    },
    {
      path: "/chapter/:chapterId",
      name: "chapter",
      component: Chapter,
      props: true,
      children: [
        {
          path: "screen/:screenId",
          name: "chapter.screen",
          component: Screen,
          props: true
        }
      ]
    }
  ]
});
